// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimSearchModel {
    static getAttributeTypeMap() {
        return ClaimSearchModel.attributeTypeMap;
    }
}
ClaimSearchModel.discriminator = undefined;
ClaimSearchModel.attributeTypeMap = [
    {
        "name": "ids",
        "baseName": "ids",
        "type": "Array<number>"
    },
    {
        "name": "claimGroupIds",
        "baseName": "claimGroupIds",
        "type": "Array<number>"
    },
    {
        "name": "parentClaimIds",
        "baseName": "parentClaimIds",
        "type": "Array<number>"
    },
    {
        "name": "memberNumbers",
        "baseName": "memberNumbers",
        "type": "Array<string>"
    },
    {
        "name": "claimStatusIds",
        "baseName": "claimStatusIds",
        "type": "Array<number>"
    },
    {
        "name": "paymentTypeIds",
        "baseName": "paymentTypeIds",
        "type": "Array<number>"
    },
    {
        "name": "externalReferences",
        "baseName": "externalReferences",
        "type": "Array<ClaimKeyValuePairLongString>"
    },
    {
        "name": "isInPaymentBatch",
        "baseName": "isInPaymentBatch",
        "type": "boolean"
    },
    {
        "name": "promotionId",
        "baseName": "promotionId",
        "type": "number"
    },
    {
        "name": "requestedPaymentTypeId",
        "baseName": "requestedPaymentTypeId",
        "type": "number"
    },
    {
        "name": "processorId",
        "baseName": "processorId",
        "type": "number"
    },
    {
        "name": "conditionTypeId",
        "baseName": "conditionTypeId",
        "type": "number"
    },
    {
        "name": "conditionIsOpen",
        "baseName": "conditionIsOpen",
        "type": "boolean"
    }
];
//# sourceMappingURL=claimSearchModel.js.map